// §14.2 #3 決議：檢查碼採 Mod-11（weights 2..7 由右循環）。
// 餘數為 10 的序號在產號時直接跳過，因此所有已發出的號碼檢查碼都是 0~9 單一數字。
export function mod11Digits(payload) {
    const digits = payload.replace(/\D/g, '');
    let sum = 0;
    let w = 2;
    for (let i = digits.length - 1; i >= 0; i--) {
        sum += Number(digits[i]) * w;
        w = w === 7 ? 2 : w + 1;
    }
    const r = (11 - (sum % 11)) % 11;
    return r; // 可能為 10（產號時跳過）
}
export function appendCheck(payload) {
    const c = mod11Digits(payload);
    if (c === 10)
        return null;
    return `${payload}-${c}`;
}
/** 驗證帶檢查碼的完整號碼 */
export function verifyId(full) {
    const m = full.trim().match(/^(.*)-(\d)$/);
    if (!m)
        return false;
    return mod11Digits(m[1]) === Number(m[2]);
}
//# sourceMappingURL=checkdigit.js.map